import { fg } from '@atlaskit/platform-feature-flags/fg';

const ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    id
    title
    type
    subtype
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;

const ExternalDocumentFragment = `
  fragment ExternalDocumentFragment on ExternalDocument {
    __typename
    id
    displayName
    url
    documentType: type {
      category
    }
    parent @optIn(to: "ExternalDataDepotQueryV2") {
      ... on ExternalDocument {
        displayName
      }
    }
    provider {
      providerId
    }
  }
`;

const JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    id
    key
    summary
    webUrl
    issueTypeAvatarUrl
    issueType {
      name
    }
    project {
      name
    }
  }
`;

const ExternalPullRequestFragment = `
  fragment ExternalPullRequestFragment on ExternalPullRequest {
    __typename
    id
    displayName
    url
    status
    provider {
      providerId
    }
  }
`;

export const operationName: string = 'QuickFindRecommendedDocumentsQuery';

/**
 * The document is built per call so `quick_find_recommendations_for_issue_pr` is read at
 * request time. As a module-level constant the gate would be read once at import, which
 * for consumers that import this module before FeatureGates has initialised pins the
 * document to the control shape for the whole page load.
 */
export const quickFindRecommendedDocumentsQuery: () => string = () => {
	const includeIssueAndPullRequest = fg('quick_find_recommendations_for_issue_pr');

	return `
  query ${operationName} (
    $userId: String!,
    $tenantId: String!,
    $caller: String!,
    $maxNumberOfResults: Int!,
    $featureServiceModel: String
  ) {
    contextService {
      quickfindUserRecommendations(
        recommendationsQuery: {
          context: {
            userId: $userId
            tenantId: $tenantId
          }, modelRequestParams: {
            caller: $caller
            experience: "recommendedExternalDocument"
            featureServiceModel: $featureServiceModel
          },
          requestingUserId: $userId
          maxNumberOfResults: $maxNumberOfResults
        }
      ) {
        id
        score
        reason
        object {
          ...ConfluencePageFragment
          ...ExternalDocumentFragment
          ${includeIssueAndPullRequest ? `...JiraIssueFragment` : ''}
          ${includeIssueAndPullRequest ? `...ExternalPullRequestFragment` : ''}
        }
      }
    }
  }
  ${ConfluencePageFragment}
  ${ExternalDocumentFragment}
  ${includeIssueAndPullRequest ? JiraIssueFragment : ''}
  ${includeIssueAndPullRequest ? ExternalPullRequestFragment : ''}
`;
};
